<ix-content-header slot="header" header-title="Projects"> </ix-content-header>
@if (!areProjectsLoading) {
  <div>
    @if (projects.length) {
      <ix-button class="m-1" variant="primary" icon="add" (click)="addProject()">Add</ix-button>

      <table class="ix-table ix-table-striped">
        <colgroup>
          <col class="column-number" />
          <col class="column-name" />
          <col class="column-actions" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (project of projects; track project; let i = $index) {
            <tr>
              <th scope="row">{{ i }}</th>
              <td>{{ project.name }}</td>
              <td>
                <ix-icon-button
                  variant="primary"
                  icon="start-data-analysis"
                  (click)="startCalculation(project.id)"
                ></ix-icon-button>
                <ix-icon-button icon="pen" variant="secondary" (click)="editProject(project)"></ix-icon-button>
                <ix-icon-button icon="trashcan" variant="secondary" (click)="openDeleteModal(project)"></ix-icon-button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    @if (projects && projects.length === 0) {
      <ix-empty-state
        header="No projects available"
        subHeader="Create a project first"
        icon="add"
        action="Create project"
        (actionClick)="addProject()"
      ></ix-empty-state>
    }
  </div>
}

<app-project-modals #projectModals></app-project-modals>
